import { useNavigate } from "react-router-dom";
import classes from "./Footer.module.css";
import DiscordFooterIcon from "../../icon/DiscordFooterIcon";
import { env } from "../../constants/env";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <div className={classes.wrapper}>
      <div className={` d-flex justify-content-between align-items-center `}>
        <div onClick={() => navigate("/")} role="button">
          <img
            src={`/PROPTRADING.FUN-LOGO.svg`}
            alt="Prop Trading Fun Logo"
            priority
          />
        </div>
        <div className="d-flex align-items-center gap-3">
          <a href={`${env.siteUrl}/terms`} target="_blank">
            <button>Terms of service</button>
          </a>
          <DiscordFooterIcon />
        </div>
      </div>
    </div>
  );
};

export default Footer;
